var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"boxes",class:{'boxes2':_vm.oushu}},_vm._l((_vm.images),function(item,index){return _c('div',{staticClass:"box",on:{"click":_vm.changeStatus}},[_c('img',{staticClass:"box-img",attrs:{"src":`${_vm.fileServerUrl+item}`}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }